const actionTypes = { CURBSIDE_CONCIERGE_INFO_MODAL: 'CURBSIDE_CONCIERGE_INFO_MODAL' };

module.exports = actionTypes;
